import { TFdrFlatDestination } from '@hotelplan/fdr.regular.fusion.fdr-travel-destination';

export function getDestinationName(item: TFdrFlatDestination): string {
  return item.canonicalName || item.name;
}
